import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from "../assets/jglogo.jpg";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Events', path: '/events' },
    { name: 'Live Updates', path: '/live-updates' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Spotlight', path: '/spotlight' },
    { name: 'FAQs', path: '/faqs' },
    { name: 'Contact', path: '/contact' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass-effect shadow-lg" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img src={logo} alt='JG Group' className='h-14 w-14'/>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${
                  isActive(link.path)
                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white shadow-lg'
                    : 'text-gray-700 hover:bg-orange-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/registration"
              data-testid="nav-register-btn"
              className="px-6 py-2 ml-2 rounded-full bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold hover:shadow-lg transition-all"
            >
              Register
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden pb-4" data-testid="mobile-menu">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all mb-1 ${
                  isActive(link.path)
                    ? 'bg-gradient-to-r from-orange-500 to-orange-600 text-white'
                    : 'text-gray-700 hover:bg-orange-50'
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/registration"
              onClick={() => setIsOpen(false)}
              data-testid="mobile-register-btn"
              className="block px-4 py-3 mt-2 rounded-lg bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold text-center"
            >
              Register Now
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;